export enum LegalStatusType {
  COOKIE = 'Cookie',
  GDPR = 'Gdpr',
  TERMS_AND_CONDITIONS = 'T&C'
}

export enum LegalStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export interface LegalsModel {
  id: string;
  name: string;
  content: string;
  type: LegalStatusType;
  status: LegalStatus;
}

export interface ListLegalsResponse {
  result: LegalsModel[];
  limit: number;
  offset: number;
  count: number;
}

export interface DeleteLegalParams {
  legalId: string;
}

export interface CreateLegalParams {
  name: string;
  content: string;
  type: LegalStatusType;
  status: LegalStatus;
}

export interface UpdateLegalParams extends CreateLegalParams {}

export interface UpdateLegalParamsWithId extends UpdateLegalParams {
  legalId: string;
}

export interface DeleteLegalParams {
  legalId: string;
}

export type LegalSortingFields = 'name';
